// removed by extract-text-webpack-plugin
module.exports = {"capabilities":"_2cL7","table":"_2tpm"};


//////////////////
// WEBPACK FOOTER
// ./src/features/PhoneSystem/PhoneSystemDidNumbersAvailableTable/PhoneSystemDidNumbersAvailableTable.scss
// module id = S7aG
// module chunks = 0